import { get } from './requests'

export const getRoleMenuItems = key => params =>
  get(['role-menu-items'], { key, transformPayload: true, params })
